import { render, staticRenderFns } from "./AddServiceCenterPage.vue?vue&type=template&id=2e1306b5"
import script from "./AddServiceCenterPage.vue?vue&type=script&lang=js"
export * from "./AddServiceCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports